export function ident<T>(x: T): T {
  return x;
}

export function keysOf<TMap extends Record<string, unknown>>(map: TMap): (keyof TMap)[] {
  return Object.keys(map);
}

export function entriesOf<TMap extends Record<string, unknown>>(map: TMap): [keyof TMap, TMap[keyof TMap]][] {
  return Object.entries(map) as unknown as [keyof TMap, TMap[keyof TMap]][];
}

export function valuesOf<TMap extends Record<string, unknown>>(map: TMap): TMap[keyof TMap][] {
  return Object.values(map) as unknown as TMap[keyof TMap][];
}

export function fromEntries<TKey extends string, TValue>(entries: [TKey, TValue][]): Record<TKey, TValue> {
  return Object.fromEntries(entries) as Record<TKey, TValue>;
}

export function mapRecord<Key extends string, From, To>(
  object: Record<Key, From>,
  map: (entry: { key: Key; value: From }) => To,
): Record<Key, To> {
  const mappedEntries = entriesOf(object).map((entry): [Key, To] => [
    entry[0],
    map({ key: entry[0], value: entry[1] }),
  ]);
  return fromEntries(mappedEntries);
}
